import React from 'react';

import PageTitle from '../../common/PageTitle';

import MainBlock from './MainBlock';

const PricingPlansPage = () => {
  return (
    <>
      <PageTitle title="Тарифы" />
      <MainBlock />
    </>
  );
};

export default PricingPlansPage;
